<ng-content></ng-content>
@if (showEye) {
  <button mat-icon-button (click)="toggleShowPassword($event)">
    <mat-icon [svgIcon]="showPassword ? 'eye-off' : 'eye-on'" />
  </button>
}
